import React from 'react';
import PropTypes from 'prop-types';
import { GigCardContextProvider } from '../gig_card_context';
import './style.scss';

const GigCardsRepeater = ({ context, children, responsiveGrid }) => {
    const classes = ['react-gig-cards-slider', 'slider-hider', 'cf'];

    responsiveGrid && classes.push('row');

    return (
        <GigCardContextProvider value={context}>
            <div className={classes.join(' ')}>
                {children.map((child, i) => <div key={`gig_item_${i}`} className={`gig-item ${context.cardSize}`}>{child}</div>)}
            </div>
        </GigCardContextProvider>
    );
};

GigCardsRepeater.propTypes = {
    context: PropTypes.object,
    children: PropTypes.array,
    responsiveGrid: PropTypes.bool
};

export default GigCardsRepeater;



// WEBPACK FOOTER //
// ./src/shared/gig_cards_repeater/index.js